import JSZip from 'jszip'

function csvCell(value) {
  let text = value === null || value === undefined ? '' : String(value)
  if (/^[=+\-@\t\r]/.test(text.trimStart())) {
    text = `'${text}`
  }
  return `"${text.replace(/"/g, '""')}"`
}

export function rowsToCsv(rows, columns) {
  const safeRows = Array.isArray(rows) ? rows : []
  const safeColumns = Array.isArray(columns) ? columns : []
  const header = safeColumns.map(c => csvCell(c.label ?? c.key ?? '')).join(',')
  const body = safeRows.map(row =>
    safeColumns.map(c => csvCell(row?.[c.key] ?? '')).join(',')
  ).join('\n')
  return `${header}\n${body}`
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 0)
}

export function downloadCsv(rows, columns, filename) {
  const blob = new Blob([rowsToCsv(rows, columns)], { type: 'text/csv;charset=utf-8' })
  downloadBlob(blob, filename)
}

export async function downloadCsvZip(files, filename) {
  const zip = new JSZip()
  files.forEach(file => {
    zip.file(file.name, rowsToCsv(file.rows, file.columns))
  })
  const blob = await zip.generateAsync({ type: 'blob' })
  downloadBlob(blob, filename)
}
